import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CreateTrip from '../components/trips/CreateTrip';

const CreateTripPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header with back navigation */}
        <div className="mb-8">
          <Link
            to="/trips"
            className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-700 transition-colors mb-4"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Back to Trips</span>
          </Link>
          
          <h1 className="text-3xl font-bold text-gray-900">Create New Trip</h1>
          <p className="mt-2 text-gray-600">
            Offer a ride or schedule a trip for others to join and share costs.
          </p>
        </div>

        {/* Create Trip Form */}
        <div className="max-w-2xl mx-auto">
          <CreateTrip />
        </div>
      </div>
    </div>
  );
};

export default CreateTripPage;
